import React from 'react';
import { t, useBehaviorSubject } from '../../../utils/helpers';
import { Message } from '../message';
import coin from '../../../assets/images/coin.png';
import send from '../../../assets/images/paper_plane.svg';
// import { EmojiPicker } from '../emojiPicker/emojiPicker';
import { useMainChat } from '../hooks/useMainChat';
import { Loader } from '@ui-kit/components/loader';
import { useScrollToElem } from '@utils/hooks';

export const MainChat = () => {
  const {
    myMessage,
    handleMessage,
    messages,
    handleEmoji,
    sendMessage,
    joinTable,
    joinPrivatChat,
  } = useMainChat();
  function joinBtnJSX(tid: number | undefined) {
    const tableId = tid || -1;
    if (tableId >= 0) {
      const numberTable = tableId + 1;
      return (
        <button
          className="messages__button-table"
          onClick={() => joinTable(tableId)}
        >{`${t('table')} ${numberTable}`}</button>
      );
    }
  }

  function joinPrivatChatBtnJSX(pid?: number, recipientName?: string) {
    if (pid && recipientName) {
      return (
        <button
          className="messages__button-table"
          onClick={() => joinPrivatChat(pid)}
        >
          {t('chat')}
        </button>
      );
    }
  }

  const endElem = useScrollToElem();

  function renderMessages(messages: Message[]) {
    return messages.map((elem, index) => {
      const authorJSX = elem.senderName ? (
        <div
          style={{color: elem.color}}
          className={
            elem.recipientName
              ? 'messages__author messages__author--private'
              : 'messages__author'
          }
          onClick={() => joinPrivatChat(elem.pid)}
        >
          {elem.senderName}
          {elem.moneyPlayer ? (
            <img className="messages__author-ticket" src={coin} alt="ticket" />
          ) : null}
          :
        </div>
      ) : (
        ''
      );

      return (
        <div className="messages-list" key={`${elem.text}_${index}`}>
          {authorJSX}
          <div style={{color: authorJSX ? 'white' : '#40E3FC'}} className="messages__text">{`${elem.text}`}</div>
          <div className="messages__button-wrap">{joinBtnJSX(elem.tid)}</div>
          <div className="messages__button-wrap">
            {joinPrivatChatBtnJSX(elem.pid, elem.recipientName)}
          </div>
        </div>
      );
    });
  }

  return (
    <>
      <main className="lobby-chat__messages">
        {renderMessages(messages)}
        <div ref={endElem} />
      </main>
      <footer className="lobby-chat__footer">
        <form className="messages-form" action="" onSubmit={sendMessage}>
          <div className="messages-form__send-area">
            <input
              className="messages-form__input"
              type="text"
              placeholder={`${t('input_text_here')}...`}
              value={myMessage}
              onChange={handleMessage}
            />
          </div>
          <div className="messages-form__emoji">
            {/* <EmojiPicker handleEmoji={handleEmoji} /> */}
          </div>
          <div className="messages-form__send">
            <button className="messages-form__button-send">
              <img src={send} alt="button send" />
            </button>
          </div>
        </form>
      </footer>
    </>
  );
};
